import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as signalR from '@microsoft/signalr';

import Api, { baseURLApiSignalrHub } from '../services/api';
import { markStepCompletedFromHub } from '../redux/actions/onboarding';
import { isAuthRoute } from '../components/onboarding/configs/onboarding.config';

/**
 * Provider SignalR dedicado pro onboarding.
 * Conecta no Hub de notificacoes e escuta o evento 'OnOnboardingProgressUpdated'
 * disparado pelo backend (Mexx.Messenger.SignalrHub:OnboardingProgressUpdatedHandler)
 * via Clients.User(userId.toString()).SendAsync(...).
 *
 * Atualiza o Redux em tempo real quando um step e marcado pelo handler.
 *
 * Renderiza apenas {children} — sem UI propria.
 */
class OnboardingHubProvider extends Component {
    constructor(props) {
        super(props);
        this.connection = null;
    }

    async componentDidMount() {
        await this.maybeConnect();
    }

    async componentDidUpdate(prevProps) {
        const prevUserId = prevProps.userSession?.user?.id;
        const currUserId = this.props.userSession?.user?.id;
        if (prevUserId !== currUserId) {
            await this.disconnect();
            await this.maybeConnect();
        }
    }

    async componentWillUnmount() {
        await this.disconnect();
    }

    maybeConnect = async () => {
        const user = this.props.userSession?.user;
        const userId = user?.id;
        const accessToken = localStorage.getItem('accesstoken');
        if (!userId || !accessToken) return;
        if (this.connection) return;

        // Gate de pre-login: nao conectar em rotas de auth
        if (isAuthRoute(window?.location?.pathname)) return;

        try {
            const hubUrl = baseURLApiSignalrHub || '';

            if (!hubUrl) {
                // Hub URL nao configurada — pula sem quebrar (api.js ainda nao carregou config).
                return;
            }

            this.connection = new signalR.HubConnectionBuilder()
                .withUrl(`${hubUrl}/hub/notification`, {
                    accessTokenFactory: () => localStorage.getItem('accesstoken') || '',
                })
                .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
                .configureLogging(signalR.LogLevel.Warning)
                .build();

            this.connection.on('OnOnboardingProgressUpdated', (payload) => {
                if (!payload) return;
                const stepId = payload.stepId ?? payload.stepid;
                const completedAt = payload.completedAt ?? payload.completedat;
                const allStepsCompleted =
                    payload.allStepsCompleted ?? payload.allstepscompleted ?? false;
                if (stepId) {
                    this.props.markStepCompletedFromHub(stepId, completedAt, allStepsCompleted);
                }
            });

            await this.connection.start();
        } catch (err) {
            // Silencioso — nao quebra app se Hub estiver fora.
            // eslint-disable-next-line no-console
            console.warn('OnboardingHub: nao foi possivel conectar', err?.message);
            this.connection = null;
        }
    };

    disconnect = async () => {
        if (!this.connection) return;
        try {
            await this.connection.stop();
        } catch (err) {
            // ignore
        }
        this.connection = null;
    };

    render() {
        return this.props.children || null;
    }
}

const mapStateToProps = (state) => ({
    userSession: state.userSession,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ markStepCompletedFromHub }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingHubProvider);
